import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  toggle(event) {
    const button = event.currentTarget
    const inputId = button.dataset.inputId
    const input = inputId ? document.getElementById(inputId) : this.inputTarget

    if (!input) return

    const isPassword = input.type === "password"
    input.type = isPassword ? "text" : "password"

    const eyeIcon = button.querySelector(".icon-eye")
    const eyeOffIcon = button.querySelector(".icon-eye-off")
    if (eyeIcon && eyeOffIcon) {
      eyeIcon.style.display = isPassword ? "none" : ""
      eyeOffIcon.style.display = isPassword ? "" : "none"
    }
  }
}
